import { create } from 'zustand';
import type { ShardState, ShardNode, ShardPlayerEntry } from '@annopolis/shared';

interface ShardStore {
  shard: ShardState | null;
  raidCooldowns: Map<string, number>; // targetId → expiry ms
  activeRaidCount: number;
  setShard: (s: ShardState | null) => void;
  updateNodes: (nodes: Array<{ id: number; ownerId: string | null; controlScore: number }>) => void;
  updateLeaderboard: (lb: ShardPlayerEntry[]) => void;
  setRaidCooldown: (targetId: string, expiryMs: number) => void;
  clearExpiredCooldowns: () => void;
}

export const useShardStore = create<ShardStore>((set, get) => ({
  shard: null,
  raidCooldowns: new Map(),
  activeRaidCount: 0,

  setShard: (s) => set({ shard: s }),

  updateNodes: (nodes) => {
    const { shard } = get();
    if (!shard) return;
    const updatedNodes = shard.nodes.map((n: ShardNode) => {
      const update = nodes.find((u) => u.id === n.id);
      return update ? { ...n, ownerId: update.ownerId, controlScore: update.controlScore } : n;
    });
    set({ shard: { ...shard, nodes: updatedNodes } });
  },

  updateLeaderboard: (lb) => {
    const { shard } = get();
    if (!shard) return;
    set({ shard: { ...shard, leaderboard: lb } });
  },

  setRaidCooldown: (targetId, expiryMs) => {
    const map = new Map(get().raidCooldowns);
    map.set(targetId, expiryMs);
    set({ raidCooldowns: map });
  },

  clearExpiredCooldowns: () => {
    const now = Date.now();
    const map = new Map(get().raidCooldowns);
    for (const [id, expiry] of map.entries()) {
      if (expiry <= now) map.delete(id);
    }
    set({ raidCooldowns: map });
  },
}));
